import { useContext } from 'react'
import { toast } from 'react-toastify'

import { typesCounter } from './../../../../../context/types/typesCounter'
import { AparienciaContext } from '../../../../../context/aparienciaContext/AparienciaProvider'
import { UserCounterContext } from '../../../../../context/userCounter/UserCounterProvider'
import { AuthContext } from '../../../../../context/auth/AuthProvider'
import { useRemoveRoleFromUserMutation, useGetPlatformRolesQuery } from '../../../../../store/api/identia'

import './userCounter.sass'
// import Notification, { type } from '../../../../general/toast/Toast';

export const DeleteUser = ({ setShowModalDelete, data }: any): JSX.Element => {
    const { dispatch } = useContext(UserCounterContext)
    const { user: authState } = useContext(AuthContext)
    const { state: stateApariencia } = useContext(AparienciaContext)
    const { id } = data

    const [removeRole] = useRemoveRoleFromUserMutation()
    const { data: platformRoles = [] } = useGetPlatformRolesQuery({
        platformId: authState.platform?.id || 'multiedu',
    })

    const deleteSubmit = async () => {
        try {
            const estudianteRole = platformRoles.find((r: any) =>
                r.name.toLowerCase().includes('estudiante'),
            )

            if (!estudianteRole) {
                toast.error('No se pudo determinar el rol para desvincular al usuario.')
                return
            }

            await removeRole({
                userId: id,
                roleId: estudianteRole.id,
                context_type: 'entity',
                context_id: stateApariencia.currentIdEntity,
            }).unwrap()

            dispatch({
                type: typesCounter.deleteUserCounter,
                payload: id,
            })
            setShowModalDelete(false)
            toast.success('El usuario se ha eliminado correctamente.')
        } catch (error: any) {
            console.error(error)
            toast.error(
                error.data?.message || 'Ha ocurrido un error al intentar eliminar usuario.',
            )
        }
    }

    return (
        <div className="main_Delete">
            <div className="headModal">
                <h3>Aviso</h3>
                <i
                    className="fas fa-times-circle"
                    onClick={() => setShowModalDelete(false)}
                />
            </div>
            <div className="bodyModals">
                <p>¿Está seguro de eliminar el alumno?</p>
                <div>
                    <button onClick={() => setShowModalDelete(false)}>Cancelar</button>
                    <button className="saveButton" onClick={deleteSubmit}>
                        Aceptar
                    </button>
                </div>
            </div>
        </div>
    )
}
